<template>
  <v-app>
    <!-- Header -->
    <Header v-if="$store.state.login" />

    <!-- Menu Lateral -->
    <Sidebar v-if="$store.state.login" />

    <!-- Conteúdo principal -->
    <v-content v-if="$store.state.login || this.$route.path == '/login'">
      <router-view></router-view>
    </v-content>

    <!-- Footer -->
    <Footer v-if="$store.state.login"></Footer>

    <!--
      Overlay de erro de API (rede/servidor).
      Usamos um div fixo simples (em vez de v-dialog) para garantir que
      a mensagem apareça mesmo quando nada mais foi renderizado ainda
      (ex.: F5 numa rota protegida com a API fora do ar).
    -->
    <div v-if="erroApi" class="erro-api-overlay">
      <div class="erro-api-card">
        <h2 class="erro-api-titulo">Erro de comunicação</h2>
        <p v-if="tentandoNovamente">Tentando conexão novamente...</p>
        <p v-else>Não foi possível se comunicar com o servidor.</p>
        <p v-if="mensagemErroApi && !tentandoNovamente" class="erro-api-detalhe">
          <small>{{ mensagemErroApi }}</small>
        </p>
        <p v-if="!tentandoNovamente">Verifique sua conexão e tente novamente. Se o problema persistir, contate o suporte.</p>
        <div class="erro-api-acoes">
          <button class="erro-api-btn erro-api-btn-secundario" :disabled="tentandoNovamente" @click="sairSistema">Sair</button>
          <button class="erro-api-btn" :disabled="tentandoNovamente" @click="tentarNovamente">
            {{ tentandoNovamente ? "Tentando..." : "Tentar novamente" }}
          </button>
        </div>
      </div>
    </div>

    <v-snackbar v-model="snackVersaoBloqueada" color="warning" :timeout="12000" bottom>
      {{ mensagemSnackVersaoBloqueada }}
    </v-snackbar>
  </v-app>
</template>
<style>
@keyframes autofill {
  to {
    color: #666;
    background: transparent;
  }
}

@-webkit-keyframes autofill {
  to {
    color: #666;
    background: transparent;
  }
}

input:-webkit-autofill {
  -webkit-animation-name: autofill;
  -webkit-animation-fill-mode: both;
}
.v-menu__content {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.erro-api-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.erro-api-card {
  background: #fff;
  border-radius: 4px;
  padding: 24px;
  max-width: 480px;
  width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  font-family: Roboto, sans-serif;
}
.erro-api-titulo {
  color: #d32f2f;
  margin: 0 0 16px 0;
  font-size: 20px;
}
.erro-api-detalhe {
  color: #666;
}
.erro-api-acoes {
  text-align: right;
  margin-top: 16px;
}
.erro-api-btn {
  background: #1976d2;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.erro-api-btn:disabled {
  background: #999;
  cursor: not-allowed;
}
.erro-api-btn-secundario {
  background: #6b7280;
  margin-right: 8px;
}
</style>
<script>
//import Vue from "vue";
import VueCookies from "vue-cookies";
import Header from "@/components/Header.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
import { ehErroVersaoInvalida } from "@/utils/versao";

export default {
  name: "App",
  components: {
    Header,
    Sidebar,
    Footer
  },
  created() {
    if (VueCookies.isKey("token")) {
      if (!this.$store.state.usuario.id) {
        this.restaurarSessao();
      }
    }
  },
  mounted() {
    //* Sincroniza sessão entre abas: se em outra aba o usuário fez logout
    //* (token foi removido), ao voltar para esta aba mandamos para o /login.
    this.verificarSessaoApp = () => {
      if (this.$store.state.login && !VueCookies.isKey("token")) {
        this.$store.dispatch("deslogarUsuario");
      }
    };
    window.addEventListener("focus", this.verificarSessaoApp);
    document.addEventListener("visibilitychange", this.verificarSessaoApp);

    this.notificarBloqueioVersaoApp = (evento) => {
      const detalhe = evento && evento.detail ? evento.detail : {};
      const tentativas = detalhe.maxTentativas || 3;
      this.mensagemSnackVersaoBloqueada = `Não foi possível atualizar a versão. Tente manualmente (Ctrl+F5).`;
      this.snackVersaoBloqueada = true;
    };
    window.addEventListener("suita:versao-auto-reload-bloqueado", this.notificarBloqueioVersaoApp);
  },
  beforeDestroy() {
    if (this.verificarSessaoApp) {
      window.removeEventListener("focus", this.verificarSessaoApp);
      document.removeEventListener("visibilitychange", this.verificarSessaoApp);
    }
    if (this.notificarBloqueioVersaoApp) {
      window.removeEventListener("suita:versao-auto-reload-bloqueado", this.notificarBloqueioVersaoApp);
    }
  },
  data: () => ({
    erroApi: false,
    mensagemErroApi: "",
    tentandoNovamente: false,
    snackVersaoBloqueada: false,
    mensagemSnackVersaoBloqueada: "Não foi possível atualizar a versão. Tente manualmente (Ctrl+F5)."
  }),
  computed: {
    //* Observa o estado de login para fechar o overlay automaticamente caso
    //* o getUsuario original (que estava pendurado) tenha eventualmente
    //* respondido com sucesso depois que a API voltou — sem isso, o usuário
    //* ficaria preso no overlay mesmo já estando logado.
    estaLogado() {
      return this.$store.state.login;
    }
  },
  watch: {
    estaLogado(novo) {
      if (novo && this.erroApi) {
        this.erroApi = false;
        this.mensagemErroApi = "";
      }
    }
  },
  methods: {
    //* Restaura a sessão a partir do token em cookie.
    //* - Em caso de 401 (token inválido/expirado): limpa estado e redireciona para /login.
    //* - Em caso de erro de rede/servidor (POOL CLOSED, 5xx, timeout): exibe overlay
    //*   com botão "Tentar novamente" em vez de tela em branco. Não limpa o token.
    //* Promise que rejeita após `ms` milissegundos. Usada para evitar que o
    //* getUsuario fique pendurado quando a API trava antes de responder ao
    //* preflight CORS (caso POOL CLOSED), o que deixaria a tela em branco
    //* indefinidamente já que o axios timeout padrão é de 10 minutos.
    timeoutPromise(ms) {
      return new Promise((_, reject) => {
        setTimeout(() => {
          const err = new Error("Tempo esgotado aguardando resposta do servidor.");
          err.code = "FRONT_TIMEOUT";
          reject(err);
        }, ms);
      });
    },
    //* Retorna true quando o erro é de token/sessão inválida (400).
    //* Na API: 400 = token/sessão expirado ou inválido; 401 = demais erros
    //* de validação ou conexão ao banco — esses não devem forçar logout.
    ehErroDeToken(e) {
      const status = e && e.response && e.response.status;
      return status === 400 && !ehErroVersaoInvalida(e);
    },
    restaurarSessao() {
      //* Captura o token antes do dispatch porque a action limpa o cookie em caso
      //* de erro, e queremos preservá-lo se for falha de rede/servidor (não 401).
      const tokenAnterior = VueCookies.get("token");
      Promise.race([this.$store.dispatch("getUsuario"), this.timeoutPromise(10000)]).catch((e) => {
        // eslint-disable-next-line no-console
        console.error("[App] Falha ao restaurar sessão:", e);
        if (this.ehErroDeToken(e)) {
          //* Token inválido/expirado — limpa estado e redireciona para login
          this.$store.dispatch("deslogarUsuario");
          return;
        }
        //* Erro de servidor/rede: restaura o token no cookie e mostra overlay
        if (tokenAnterior) {
          VueCookies.set("token", tokenAnterior, "12h", "/", "", true, "Strict");
        }
        this.mensagemErroApi = this.formatarMensagemErro(e);
        this.erroApi = true;
      });
    },
    formatarMensagemErro(e) {
      if (!e) return "";
      if (e.code === "FRONT_TIMEOUT") {
        return "O servidor não respondeu a tempo. Pode estar fora do ar ou sobrecarregado.";
      }
      if (e.response) {
        const data = e.response.data;
        const msg = (data && (data.message || data.erro || data.error)) || e.response.statusText;
        return `Erro ${e.response.status}${msg ? ": " + msg : ""}`;
      }
      if (e.request) {
        return "Servidor não respondeu (verifique sua conexão).";
      }
      return e.message || String(e);
    },
    tentarNovamente() {
      this.tentandoNovamente = true;
      this.mensagemErroApi = "";
      const tokenAnterior = VueCookies.get("token");
      Promise.race([this.$store.dispatch("getUsuario"), this.timeoutPromise(10000)])
        .then(() => {
          this.erroApi = false;
        })
        .catch((e) => {
          if (this.ehErroDeToken(e)) {
            //* Token inválido/expirado — limpa estado e redireciona para login
            this.erroApi = false;
            this.$store.dispatch("deslogarUsuario");
            return;
          }
          //* Mantém o overlay aberto e atualiza a mensagem
          if (tokenAnterior) {
            VueCookies.set("token", tokenAnterior, "12h", "/", "", true, "Strict");
          }
          this.mensagemErroApi = this.formatarMensagemErro(e);
        })
        .finally(() => {
          this.tentandoNovamente = false;
        });
    },
    sairSistema() {
      this.erroApi = false;
      this.mensagemErroApi = "";
      this.$store.dispatch("deslogarUsuario");
    }
  },
  props: {
    source: String
  }
};
</script>
